// extracted by mini-css-extract-plugin
export default {"styleTypeSelect":"index_styleTypeSelect__PiKvv"};